import AbstractTextInput from "../text/AbstractTextInput";

class TextAreaInput extends AbstractTextInput {
    specs = {
        textTransform : 'regular',
        helperText: "Maximum 255 caractères",
        inputProps : { maxLength: 255 }
    }
}

export default TextAreaInput